const setBroadCart: any = {
	inserted(el: any) {
		// el.querySelector('.list').style.height = (el.querySelector('.box').offsetHeight - 26)+'px';
		if (el.querySelector(".cart")) el.querySelector(".cart").style.bottom = el.querySelector(".box").offsetHeight + 8 + "px";
	},
};
export default setBroadCart;
